import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { aboutInfo } from '@/mocks/articles';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-950">
        <Navbar />
        <main>
          {/* Hero */}
          <section className="relative w-full">
            <div className="relative h-[320px] md:h-[400px] w-full overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20office%20interior%20with%20warm%20dark%20wood%20tones%2C%20professional%20workspace%20with%20monitors%20and%20desks%2C%20soft%20ambient%20lighting%2C%20tech%20company%20office%2C%20dark%20moody%20atmosphere%2C%20cinematic%20photography&width=1920&height=600&seq=about-hero-2026&orientation=landscape"
                alt="关于51吃瓜"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center px-4">
                  <h1 className="text-3xl md:text-4xl font-bold text-foreground-50 mb-3">关于我们</h1>
                  <p className="text-sm md:text-base text-foreground-400 max-w-xl">
                    吃瓜不迷路，就上51吃瓜
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
                <h2 className="text-lg font-bold text-foreground-100">品牌介绍</h2>
              </div>
              <div className="bg-background-900/80 rounded-xl border border-background-800/50 p-6 md:p-8">
                <div className="text-sm text-foreground-400 leading-relaxed space-y-4">
                  {aboutInfo.brandIntro.split('\n\n').map((para, idx) => (
                    <p key={idx}>{para}</p>
                  ))}
                </div>

                {/* Stats */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-8 border-t border-background-800/50">
                  {[
                    { value: '2020', label: '创立年份' },
                    { value: '860万+', label: '注册用户' },
                    { value: '12,580+', label: '资讯数量' },
                    { value: '98.5%', label: '用户好评率' },
                  ].map((stat) => (
                    <div key={stat.label} className="text-center">
                      <div className="text-xl md:text-2xl font-bold text-primary-400">{stat.value}</div>
                      <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section className="w-full px-4 md:px-6 pb-10 md:pb-14">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
                <h2 className="text-lg font-bold text-foreground-100">用户口碑</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {aboutInfo.reputation.map((rep) => (
                  <div
                    key={rep.platform}
                    className="bg-background-900/80 rounded-xl border border-background-800/50 p-5 text-center"
                  >
                    <div className="text-2xl font-bold text-accent-400 mb-1">{rep.rating}</div>
                    <div className="flex items-center justify-center gap-0.5 mb-2">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i
                          key={star}
                          className={`text-xs ${star <= Math.floor(rep.rating) ? 'ri-star-fill text-accent-400' : 'ri-star-line text-foreground-600'}`}
                        ></i>
                      ))}
                    </div>
                    <div className="text-sm font-medium text-foreground-300 mb-1">{rep.platform}</div>
                    <div className="text-xs text-foreground-500 mb-2">{rep.reviews} 评价</div>
                    <div className="text-xs text-foreground-400 italic">
                      &ldquo;{rep.comment}&rdquo;
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="w-full px-4 md:px-6 pb-14">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-1 h-5 bg-secondary-500 rounded-full"></div>
                <h2 className="text-lg font-bold text-foreground-100">联系我们</h2>
              </div>
              <div className="bg-background-900/80 rounded-xl border border-background-800/50 p-6 md:p-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10">
                      <i className="ri-mail-line text-primary-400 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-300 mb-1">电子邮箱</div>
                      <a href={`mailto:${aboutInfo.contact.email}`} className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                        {aboutInfo.contact.email}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-500/10">
                      <i className="ri-wechat-line text-accent-400 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-300 mb-1">微信公众号</div>
                      <span className="text-sm text-foreground-500">{aboutInfo.contact.wechat}</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-500/10">
                      <i className="ri-weibo-line text-secondary-400 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-300 mb-1">官方微博</div>
                      <span className="text-sm text-foreground-500">{aboutInfo.contact.weibo}</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-500/10">
                      <i className="ri-phone-line text-primary-400 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-300 mb-1">客服电话</div>
                      <span className="text-sm text-foreground-500">{aboutInfo.contact.phone}</span>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 sm:col-span-2 lg:col-span-2">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-500/10">
                      <i className="ri-map-pin-line text-accent-400 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-300 mb-1">公司地址</div>
                      <span className="text-sm text-foreground-500">{aboutInfo.contact.address}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}